export enum TermsOfPaymentType {
  Prepaid = 'Prepaid',
  Directpay = 'Directpay',
  Postpaid = 'Postpaid',
}
